import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TeamColors',
  props: {
    team: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "w-6 h-6 rounded rounded-r-none",
        style: _normalizeStyle({
          backgroundColor: __props.team.primaryColor
        })
      }, null, 4), _createElementVNode("div", {
        class: "w-6 h-6 rounded rounded-l-none",
        style: _normalizeStyle({
          backgroundColor: __props.team.secondaryColor
        })
      }, null, 4)]);
    };
  }
});